interface PharmacistNoteProps {
  note: string;
  name: string;
  title?: string;
  month?: string;
  className?: string;
}

export const PharmacistNote = ({
  note, name, title = 'Pharmacist', month, className = '',
}: PharmacistNoteProps) => (
  <div className={`pharmacist-note ${className}`}>
    <p className="kicker text-primary-400 mb-3">A note from your pharmacist</p>
    <p className="note-body">&ldquo;{note}&rdquo;</p>
    <span className="note-sig">
      — {name}, {title}{month ? `, ${month}` : ''}
    </span>
  </div>
);
